import { render } from "./KpiSubCategoriesSave.vue?vue&type=template&id=42eddd5e&scoped=true"
import script from "./KpiSubCategoriesSave.vue?vue&type=script&lang=js"
export * from "./KpiSubCategoriesSave.vue?vue&type=script&lang=js"

import "./KpiSubCategoriesSave.vue?vue&type=style&index=0&id=42eddd5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42eddd5e"]])

export default __exports__